import React, { useState } from 'react';
import { Loader2, Layers } from 'lucide-react';
import { resolveImageUrl } from '../../lib/imageCache';

export const FabricSelector = ({ collections, selectedColor, onSelect, loading }) => {
  const [expandedColl, setExpandedColl] = useState(null);
  const [expandedMat, setExpandedMat] = useState(null);

  if (loading) return <div className="flex justify-center py-6"><Loader2 className="w-5 h-5 animate-spin text-amber-500" /></div>;

  return (
    <div className="space-y-1 max-h-[400px] overflow-y-auto pr-1" data-testid="fabric-selector">
      {collections?.map(coll => (
        <div key={coll.collection_id}>
          <button
            onClick={() => setExpandedColl(expandedColl === coll.collection_id ? null : coll.collection_id)}
            className="w-full flex items-center gap-2 px-3 py-2 text-left hover:bg-neutral-100 rounded-lg text-sm transition-colors"
            data-testid={`room-preview-coll-${coll.collection_id}`}
          >
            <Layers className="w-3.5 h-3.5 text-neutral-400 flex-shrink-0" />
            <span className="font-medium text-neutral-800 truncate flex-1">{coll.collection_name}</span>
            {coll.openness && <span className="text-[10px] text-neutral-400 truncate max-w-[90px]">{coll.openness}</span>}
            <span className="text-[10px] text-neutral-400">{coll.material_count}</span>
          </button>

          {expandedColl === coll.collection_id && (
            <div className="ml-4 space-y-0.5">
              {coll.materials.map(mat => (
                <div key={mat.id}>
                  <button
                    onClick={() => setExpandedMat(expandedMat === mat.id ? null : mat.id)}
                    className="w-full flex items-center gap-2 px-2 py-1.5 text-left hover:bg-neutral-50 rounded-md text-xs transition-colors"
                    data-testid={`room-preview-mat-${mat.id}`}
                  >
                    <div className="w-5 h-5 rounded border border-neutral-200 overflow-hidden flex-shrink-0">
                      {mat.image_url && <img src={resolveImageUrl(mat.image_url, 128)} alt="" className="w-full h-full object-cover" onError={e => { e.target.style.display = 'none'; }} />}
                    </div>
                    <span className="text-neutral-700 truncate flex-1">{mat.name}</span>
                    <span className="text-[10px] text-neutral-400">{mat.color_count}</span>
                  </button>

                  {expandedMat === mat.id && (
                    <div className="ml-3 grid grid-cols-4 gap-1.5 py-1.5 pl-2">
                      {mat.colors.map(color => {
                        const isSelected = selectedColor?.code === color.code;
                        return (
                          <button
                            key={color.id}
                            onClick={() => onSelect(color, mat, coll)}
                            className={`aspect-square rounded-lg border-2 overflow-hidden transition-all ${
                              isSelected ? 'border-amber-500 ring-2 ring-amber-200 scale-105' : 'border-neutral-200 hover:border-neutral-400'
                            }`}
                            title={color.name}
                            data-testid={`room-preview-swatch-${color.code}`}
                          >
                            <img src={resolveImageUrl(color.image_url, 128)} alt={color.name} className="w-full h-full object-cover" loading="lazy" onError={e => { e.target.style.display = 'none'; }} />
                          </button>
                        );
                      })}
                    </div>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default FabricSelector;
